module.exports = __webpack_public_path__ + "static/media/UDAYSHANKAR-NANDI.5fa309d2.png";